import ClientDocumentsPanel from "../../Clients/ClientDocumentsPanel";

interface LeadDocumentsProps {
  clientId: number;
}

export default function LeadDocuments({ clientId }: LeadDocumentsProps) {
  return <ClientDocumentsPanel editedClient={{ id: clientId } as any} />;
}
